module.exports = __webpack_public_path__ + "static/media/ic_classinfo.3f2c022f.svg";